import React, { PropsWithChildren } from "react";
import { useBrowserTitle } from "../hooks/useBrowserTitle";

type IBrowserTitleProps = {
  title: string;
};

export const BrowserTitle = (props: PropsWithChildren<IBrowserTitleProps>) => {
  const { title, children } = props;
  useBrowserTitle(title);
  return <>{children}</>;
};
